<template>
  <svg
    data-test="extension-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.162 20"
  >
    <g>
      <g>
        <path
          fill="currentColor"
          d="M17.566,11.243c-0.095,0.106-0.206,0.19-0.337,0.252c-0.133,0.062-0.271,0.092-0.42,0.092
			c-0.262,0-0.49-0.085-0.682-0.256c-0.193-0.173-0.291-0.375-0.291-0.607c0-0.124,0.027-0.248,0.081-0.37
			c0.056-0.124,0.136-0.244,0.242-0.36l0.763-0.875H13.35h-1.432c-0.283,0-0.525-0.098-0.722-0.296
			c-0.195-0.194-0.294-0.436-0.294-0.722c0-0.29,0.099-0.535,0.294-0.729c0.196-0.195,0.438-0.29,0.722-0.29h1.432h3.572
			L16.16,6.318c-0.103-0.104-0.183-0.224-0.238-0.356c-0.056-0.134-0.085-0.271-0.085-0.418c0-0.262,0.096-0.484,0.282-0.664
			c0.187-0.179,0.415-0.27,0.69-0.27c0.146,0,0.283,0.03,0.41,0.088c0.131,0.061,0.246,0.146,0.347,0.26l2.8,3.143L17.566,11.243z"
        />
      </g>
      <path
        fill="currentColor"
        d="M15.428,17.532
		c0.254-0.217,0.316-0.584,0.134-0.87c-0.022-0.035-0.05-0.062-0.077-0.094v-0.002l-3.221-3.556l-0.003,0.002
		c-0.218-0.245-0.577-0.305-0.866-0.121c-0.023,0.018-0.045,0.037-0.071,0.06l0,0c-0.013,0.017-0.03,0.024-0.042,0.041
		c-0.34,0.308-0.345,0.361-0.623,0.632c-0.39,0.396-0.889,1.035-1.396,1.766c-1.037-0.394-2.428-1.672-3.794-3.797
		c-1.366-2.126-1.952-3.921-1.88-5.03c0.879-0.156,1.664-0.346,2.188-0.537c0.362-0.137,0.403-0.127,0.831-0.3
		c0.018-0.009,0.035-0.013,0.057-0.021V5.7c0.023-0.012,0.059-0.026,0.082-0.042c0.286-0.182,0.383-0.537,0.249-0.835l0.002-0.007
		L5.103,0.414L5.099,0.411c-0.017-0.038-0.034-0.07-0.055-0.107C4.864,0.022,4.498-0.08,4.205,0.066
		C2.096,0.925,0.147,1.938,0.012,3.611c-0.151,1.798,1.097,6.099,3.223,9.414c2.136,3.312,5.533,6.232,7.228,6.842
		C12.043,20.437,13.778,19.085,15.428,17.532"
      />
    </g>
  </svg>
</template>
